let data=[
    {
        id:0,
        imgUrl:"img/blog1.jpg",
        comment:"comment",
        title:"Fusce vel ipsum ut est lobortis tincidunt a sit amet sapien",
        contents:"Sed condimentum ipsum et felis euismod blandit. Ut in turpis eu justo lobortis posuere eu ac turpis. Nunc faucibus viverra neque, non volutpat diam ultricies ut. Mauris vestibulum, felis eget cursus iaculis, lectus dolor euismod nisl, eu molestie diam nisl..."
    },
    {
        id:1,
        imgUrl:"img/blog2.jpg",
        comment:"comment",
        title:"Nullam Vel Sodales OrciAliquam Lacinia Quam Sit Amet Sapien",
        contents:"Cras efficitur semper leo ac sagittis. Aliquam erat volutpat. Phasellus accumsan malesuada nulla, sit amet ultrices metus egestas non. Nullam dapibus placerat iaculis. In commodo maximus sagittis. In vitae consequat metus. Fusce vestibulum velit massa, vitae commodo augue feugiat et...."
    },

    {
        id:2,
        imgUrl:"img/blog3.jpg",
        comment:"comment",
        title:"Duis tincidunt ante sit amet bibendum blandit",
        contents:"Vivamus ac lorem quis mauris dignissim luctus eu at erat. Vestibulum nec mauris ultrices, maximus tortor ut, congue ipsum. Curabitur ut est tincidunt, maximus augue quis, iaculis tellus. Nullam nec ultricies erat. Pellentesque tristique dictum ligula, in porttitor eros faucibus..."

    },

    {
        id:3,
        imgUrl:"img/blog4.jpg",
        comment:"comment",
        title:"Etiam Dictum Ligula In Diam Molestie Vestibulum",
        contents:"Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Cras dignissim vehicula nisl vitae mattis. Ut pretium elit leo, a ullamcorper libero iaculis vitae. Integer nec sapien turpis. Nullam quis laoreet lectus. Integer pulvinar congue nulla, non..."

    },

    {
        id:4,
        imgUrl:"img/blog5.jpg",
        comment:"comment",
        title:"Vestibulum Felis Sem Porttitor Et Hendrerit Suscipit Quis",
        contents:"fermentum rhoncus lectus orci sit amet nisi. Nam eget nibh id est tincidunt sollicitudin. Vestibulum ipsum lorem, tincidunt vitae faucibus vitae, fermentum nec ligula. Nullam a metus rhoncus, pharetra urna vel, semper massa. Suspendisse eu nulla cursus, tristique elit sed,..."

    }
]

export default data;